import { rgba } from "polished";
import * as React from "react";
import styled, { css } from "styled-components";

import { IApiError } from "src/library/utils";

import Grid from "../Hedron";
import { Text } from "../Text";
import { Icon } from "../Icon";
import Button from "../Button/Button";
import { Icons } from "../Icon/types";

const TableErrorStyled = styled.div`
  ${({ theme }) => css`
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${rgba(theme.colors.error, 0.2)};
    
    .retry-wrapper {
      justify-content: center;
    }
    
    p {
      transition: ${theme.transition.quicker};
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      padding: 0;
      text-align: center;
      text-align: center;
      
      button {
        margin: ${theme.spacing.margins.sm} auto 0;
      }

      strong {
        font-weight: ${theme.fonts.weights.bold};
      }
    }
  `}
`;

const TableError: React.ReactFCWithChildren<{ error: IApiError; onRetry?: () => void }> = ({ error, onRetry }) => {
  return (
    <TableErrorStyled className="rt-error">
      <Text
        as="p"
        fontSize="h3"
      >
        <strong>
          Error
        </strong>
        .

        {error.message}

        <br />

        {onRetry && (
          <Grid.Bounds
            direction="horizontal"
            className="retry-wrapper"
          >
            <Button onClick={onRetry}>
              <>
                <Icon
                  $fillColor="white"
                  icon={Icons.REFRESH}
                />
                Retry
              </>
            </Button>
          </Grid.Bounds>
        )}
      </Text>
    </TableErrorStyled>
  );
};

export default TableError;
